import { FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from '@lib/api/models/user';
import { DateTime } from 'luxon';

export interface Thread {
    id: string;
    subject: string;
    sender_id: string;
    messages: Message[];
    sender: User;
    participants: Participant[];
    unread_users: User[];
    created_at: string;
    updated_at: string;
}

export interface Message {
    id: string;
    content: string;
    sender_id: string;
    sender: User;
    remove_user_indicator: boolean;
    created_at: string;
    updated_at: string;
}

export interface Participant {
    id: string;
    user_id: string;
    user: User;
    read: boolean;
    read_at: string;
    removed: boolean;
    created_at: string;
    updated_at: string;
}

export interface CreateMessageRequest {
    content: string;
    subject: string;
    recipients: User[];
}

export interface CreateReplyRequest {
    thread_id: string;
    content: string;
}

export interface ChangeParticipantPresence {
    thread_id: string;
    participant_id: string;
    removed: boolean;
}

export interface ChangeParticipantPresenceResponse {
    data: Message;
}

export interface CreateMessageSingleResponse {
    data: Message;
}

export interface CreateReplySingleResponse {
    data: Message;
}

export interface CreateParticipantSingleResponse {
    data: Participant;
}

export interface CreateReadMessageSingleResponse {
    data: Participant;
}

export interface AddMessageReplyData {
    threadId: string;
    subject: string;
}

export interface AddParticipantData {
    threadId: string;
    participants: Participant[];
}

export interface StoreCreateMessageRequest {
    content: string;
    subject: string;
    recipients: User[];
}

export interface StoreCreateReplyRequest {
    content: string;
    thread_id: string;
}

export interface StoreAddParticipantRequest {
    thread_id: string;
    participant_id: string;
}

export interface StoreReadMessageRequest {
    id: string;
    read: boolean;
}

export interface ThreadIds {
    ids: string[];
}

export interface ThreadIdsSingleResponse {
    data: ThreadIds;
}

export interface StoreThreadIdsActionRequest {
    threadIds: string[];
}

export function createMessageFormGroup(messageData?: CreateMessageRequest) {
    return new FormGroup({
        created_at: new FormControl<string>(
            { value: DateTime.local().toISODate(), disabled: true },
            Validators.required
        ),
        content: new FormControl<string>(messageData?.content ?? '', [
            Validators.required,
            Validators.minLength(1)
        ]),
        subject: new FormControl<string>(messageData?.subject ?? '', [
            Validators.required,
            Validators.minLength(1)
        ]),
        recipients: new FormControl<User[]>(messageData?.recipients ?? [], Validators.required)
    });
}

export function createReplyFormGroup(messageData?: CreateReplyRequest) {
    return new FormGroup({
        created_at: new FormControl<string>(
            { value: DateTime.local().toISODate(), disabled: true },
            Validators.required
        ),
        content: new FormControl<string>(messageData?.content ?? '', [
            Validators.required,
            Validators.minLength(1)
        ]),
        thread_id: new FormControl<string>(messageData?.thread_id ?? '', [
            Validators.required,
            Validators.minLength(1)
        ]),
    });
}

export function addParticipantFormGroup(participantData?: ChangeParticipantPresence) {
    return new FormGroup({
        thread_id: new FormControl<string>(participantData?.thread_id ?? '', [
            Validators.required,
            Validators.minLength(1)
        ]),
        participant_id: new FormControl<string>(participantData?.participant_id ?? '', [
            Validators.required,
            Validators.minLength(1)
        ]),
    });
}
